// extracted by mini-css-extract-plugin
module.exports = {"custom__switch__base":"customSwitch_custom__switch__base__2ffEF","active":"customSwitch_active__1o9tT","custom__switch__circle":"customSwitch_custom__switch__circle__2H7EO"};